 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTMAINTITLE from '@/components/Text/MainTitle'
 import TEXTCOPYRIGHT from '@/components/Text/Copyright'
 import TEXTTOC from '@/components/Text/TOC'
 import TEXTTITLEPAGE from '@/components/Text/TitlePage'
 import TEXTM from '@/components/Text/M'
 import TEXTM2 from '@/components/Text/M2'
 import TEXTN from '@/components/Text/N'
 import TEXTOP from '@/components/Text/OP'
 import TEXTQR from '@/components/Text/QR'
 import TEXTS1 from '@/components/Text/S1'
 import TEXTS2 from '@/components/Text/S2'
 import LOVE_2 from '@/components/love_2'
 import TEXTCTA from '@/components/Text/CTA'
 import TEXTBIBLIOGRAPHY from '@/components/Text/Bibliography'
 import TEXTINDEX from '@/components/Text/Index'
 import TEXTAD1 from '@/components/Text/Ad1'
 import TEXTAD2 from '@/components/Text/Ad2'
 import TEXTTEDBUNDYENCYCLOPEDIA_EXCERPTAD_V1 from '@/components/Text/TedBundyEncyclopedia_ExcerptAd_v1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/TOC",
 			"name" : "Text/TOC",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/TitlePage",
 			"name" : "Text/TitlePage",
 			"component" : TEXTTITLEPAGE
 		},
 		{
 			"path" : "/Text/M",
 			"name" : "Text/M",
 			"component" : TEXTM
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js